import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Table, TableHead, TableCell, TableBody, makeStyles, TableRow, Tooltip, } from '@material-ui/core';
import clsx from 'clsx';
import { useModeTableStyle, createHeaderColumn, createPreviewItemCell, } from '@moderepo/mode-app-components';
const useStyle = makeStyles((theme) => {
    return {
        tableCol: {
            '&.timestamp-col': {
                textAlign: 'left',
            },
            '&.tags-col': {
                textAlign: 'left',
            },
            '&.level-col': {
                textAlign: 'center',
                '& .level-value': {
                    fontSize: 'smaller',
                    fontWeight: 500,
                    padding: theme.spacing(0.3, 0.5),
                    borderRadius: 2,
                    textTransform: 'lowercase',
                    background: theme.palette.info.main,
                    color: theme.palette.info.contrastText,
                    width: '5em',
                    display: 'inline-block',
                },
                // error
                '&.level-0': {
                    '& .level-value': {
                        background: theme.palette.error.main,
                    },
                },
                // warning
                '&.level-1': {
                    '& .level-value': {
                        background: theme.palette.warning.main,
                    },
                },
                // info
                '&.level-2': {},
                // debug
                '&.level-3': {},
            },
            '&.message-col': {
                textAlign: 'left',
                width: '100%',
                whiteSpace: 'normal',
            },
            '&.caller-col': {
                textAlign: 'left',
            },
            '&.sudoer-col': {
                textAlign: 'left',
            },
        },
    };
}, {
    name: 'MessageLogsTable',
});
/**
 * This component is used for displaying MessageLogs. It is a DUMB component which does not do anything other than displaying
 * the data provided through props.
 */
export const MessageLogsTable = (props) => {
    const tableClasses = useModeTableStyle();
    const classes = useStyle();
    return (_jsxs(Table, { className: tableClasses.root, size: "medium", children: [_jsx(TableHead, { className: tableClasses.tableHeader, children: _jsx(TableRow, { className: tableClasses.tableHeaderRow, children: Object.keys(props.fieldsSettings.fields).filter((fieldName) => {
                        var _a;
                        return !((_a = props.fieldsSettings.fields[fieldName]) === null || _a === void 0 ? void 0 : _a.hidden);
                    }).map((fieldName) => {
                        const field = props.fieldsSettings.fields[fieldName];
                        if (field && !field.hidden) {
                            return createHeaderColumn(props.fieldsSettings, fieldName, field, `${tableClasses.tableCol} ${classes.tableCol} ${fieldName}-col`);
                        }
                        return _jsx(_Fragment, {});
                    }) }) }), _jsx(TableBody, { children: props.listData && props.listData.length > 0 && (props.listData.map((dataItem, index) => {
                    return (_jsx(TableRow, { className: clsx(tableClasses.tableBodyRow), onClick: () => {
                            if (props.onListItemSelected) {
                                props.onListItemSelected(dataItem.actualValue);
                            }
                        }, children: Object.keys(props.fieldsSettings.fields).filter((fieldName) => {
                            var _a;
                            return !((_a = props.fieldsSettings.fields[fieldName]) === null || _a === void 0 ? void 0 : _a.hidden);
                        }).map((fieldName) => {
                            if (fieldName === 'level' && props.fieldsSettings.fields.level
                                && !props.fieldsSettings.fields.level.hidden) {
                                return (_jsx(TableCell, { className: clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`, `level-${dataItem.actualValue.level}`), children: _jsx("span", { className: "level-value", children: dataItem.displayValue.level }) }, fieldName));
                            }
                            if (fieldName === 'caller' && props.fieldsSettings.fields.caller
                                && !props.fieldsSettings.fields.caller.hidden) {
                                return (_jsx(TableCell, { className: clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`), children: dataItem.displayValueTooltip.caller
                                        ? (_jsx(Tooltip, { title: dataItem.displayValueTooltip.caller, children: _jsx("div", { children: dataItem.displayValue.caller }) }))
                                        : (dataItem.displayValue.caller) }, fieldName));
                            }
                            if (fieldName === 'preview' && props.fieldsSettings.fields.preview
                                && !props.fieldsSettings.fields.preview.hidden) {
                                return createPreviewItemCell(dataItem, clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`), props.onPreviewItemClicked);
                            }
                            /**
                             * Handle all the other fields that don't have special UI. These are the fields that
                             * display dataItem.displayValue as plain text
                             */
                            if (props.fieldsSettings.fields[fieldName]
                                && !props.fieldsSettings.fields[fieldName].hidden) {
                                return (_jsx(TableCell, { className: clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`), children: dataItem.displayValue[fieldName] }, fieldName));
                            }
                            return _jsx(_Fragment, {});
                        }) }, `${dataItem.displayValue.timestamp}-${index.toString()}`));
                })) })] }));
};
